import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {TestOrderStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {getNavigationURL} from 'nav/sidepanel/listing/SearchURLs';
import {Filter, FilterKey, Operator, SortKey} from 'search/SearchConstants';

import {InaccessibleInfoGraphQL} from '../../../../graphql-fragments/auth/__generated/InaccessibleInfoGraphQL';
import {TestOrderListingGraphQL} from '../../../../graphql-fragments/sample_tests/__generated/TestOrderListingGraphQL';

export type BasicTestOrder = Pick<TestOrderListingGraphQL, '__typename' | 'id' | 'name'>;

export function getTestOrdersSearchUrl(
  testOrders: Array<BasicTestOrder | InaccessibleInfoGraphQL>,
  studyId?: string,
  statusIsOneOf?: Array<TestOrderStatus>
): string {
  const testOrderNames = new Set(
    testOrders
      .map((testOrder) => (!isInaccessible(testOrder) ? testOrder.name : null))
      .filter((name): name is string => name != null)
  );
  const filters: Array<Filter> = [
    {
      key: FilterKey.TYPES,
      operator: Operator.IS_ONE_OF,
      value: [ModelTypeConstants.TEST_ORDER],
    },
  ];
  if (testOrderNames.size > 0) {
    filters.push({
      key: FilterKey.NAMES,
      operator: Operator.IS_ONE_OF,
      value: [...testOrderNames],
    });
  }
  if (studyId != null) {
    filters.push({
      key: FilterKey.IN_STUDY,
      operator: Operator.IS,
      value: [studyId],
    });
  }
  if (statusIsOneOf != null) {
    filters.push({
      key: FilterKey.TEST_STATUS,
      operator: Operator.IS_ONE_OF,
      value: statusIsOneOf,
    });
  }
  return getNavigationURL(
    '/search',
    {
      offset: 0,
      limit: 25,
      sorts: [{key: SortKey.SORT_MODIFIED_AT_KEY, reverse: true}],
      filters,
      query: '',
    },
    filters.map((_) => null)
  );
}

export function getTestOrdersByContainerIdsSearchUrl(
  containerIds: Array<string>,
  statusIsOneOf?: Array<TestOrderStatus>
): string {
  assert(containerIds.length > 0, 'Unexpectly no container ids provided');

  const filters: Array<Filter> = [
    {
      key: FilterKey.TYPES,
      operator: Operator.IS_ONE_OF,
      value: [ModelTypeConstants.TEST_ORDER],
    },
    {
      key: FilterKey.SAMPLE_CONTAINER,
      operator: Operator.IS_ONE_OF,
      value: [...containerIds],
    },
  ];

  if (statusIsOneOf != null) {
    filters.push({
      key: FilterKey.TEST_STATUS,
      operator: Operator.IS_ONE_OF,
      value: statusIsOneOf,
    });
  }
  return getNavigationURL(
    '/search',
    {
      offset: 0,
      limit: 25,
      sorts: [{key: SortKey.SORT_MODIFIED_AT_KEY, reverse: true}],
      filters,
      query: '',
    },
    filters.map((_) => null)
  );
}
